import { useEffect, useState } from 'react';
import SubReasonService from 'views/subReason/service';

export const useSubreasons = (reasonId) => {
  const [subreasons, setSubreasons] = useState([]);

  useEffect(() => {
    if (!reasonId) {
      setSubreasons([]);
      return;
    }

    const fetchSubreasons = async () => {
      try {
        const response = await SubReasonService.getByReasonId(reasonId);
        setSubreasons(response?.data?.content || []);
      } catch (error) {
        console.error('Erro ao buscar submotivos:', error);
        setSubreasons([]);
      }
    };

    fetchSubreasons();
  }, [reasonId]);

  return { subreasons };
};
